import { Button, Input, Modal, Space } from "antd";
import { Alert, AntdTableCustom, FormInfo, Pagination, Toast } from "../../../../../components";
import AntdButtonCustom from "../../../../../components/AntdButtonCustom";
import classNames from "classnames/bind";
import styles from './Config.module.css';
import { DeleteIcon, EditIcon } from "../../../../../components/Icons/Icons";
import { useEffect, useState } from "react";
import { licensePlateWatchlistAPI } from "../../../../../services/api/lisencePlateWatchlist";
import { useForm } from "antd/es/form/Form";
import { objectType } from "../source";
import { formatDateToTime } from "../../../../../utils";
const cx = classNames.bind(styles);

export default function ConfigWatchlistLicensePlace() {
    const [dataSource, setDataSource] = useState([{
        stt: 1,
        licensePlate: "29A-12345",
        timeAdded: "2023-01-01 12:00:00",
    }]);
    const [showModalDetail, setShowModalDetail] = useState({
        show: false,
        record: null,
    });
    const [showAlertDelete, setShowAlertDelete] = useState({
        show: false,
        record: null,
    });
    const [searchText, setSearchText] = useState();
    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [pages, setPages] = useState({
        current: 1,
        pageSize: 10,
        totalPage: 1,
    });
    const [form] = useForm();
    const handleEdit = (record) => {
        // Logic to handle edit action 
        setShowModalDetail({
            show: true,
            record: record,
        });
        form.setFieldsValue({
            licensePlate: record?.licensePlate,
            objectType: record?.objectType,
        });
    }
    const handleDelete = (record) => {
        // Logic to handle delete action
        setShowAlertDelete({
            show: true,
            record: record,
        });
    }
    const handleCancelModal = () => {
        setShowModalDetail({ show: false, record: null });
        form.resetFields();
    }

    const handleAddNew = async () => {
        try {
            await form.validateFields().then().catch(error => { throw error });
            const license_plate = {
                license_plate: form.getFieldValue('licensePlate')?.trim(),
                object_type: form.getFieldValue('objectType'),
            }
            await licensePlateWatchlistAPI.addLicensePlate(license_plate);
            handleCancelModal();
            setRefresh(pre => !pre);
            Toast.open("Thêm biển số xe mới thành công", "success");
        } catch (error) {
            if (error?.response?.data?.result) {
                form.setFields([
                    {
                        name: 'licensePlate',
                        errors: [error?.response?.data?.result || "Lỗi khi thêm biển số xe mới"],
                    },
                ]);
                return;
            }
            Toast.open("Thêm mới biển số xe thất bại", "danger");
            return;
        }
    }

    const handleSaveEdit = async () => {
        try {
            await form.validateFields().then().catch(error => { throw error });
            const license_plate = {
                license_plate: form.getFieldValue('licensePlate')?.trim(),
                object_type: form.getFieldValue('objectType'),
            }
            await licensePlateWatchlistAPI.updateLicensePlate(showModalDetail?.record?.CODE, license_plate);
            handleCancelModal();
            setRefresh(pre => !pre);
            Toast.open("Sửa biển số xe thành công", "success");
        } catch (error) {
            if (error?.response?.data?.result) {
                form.setFields([
                    {
                        name: 'licensePlate',
                        errors: [error?.response?.data?.result || "Lỗi khi thêm biển số xe mới"],
                    },
                ]);
                return;
            }
            Toast.open("Sửa biển số xe thất bại", "danger");
            return;
        }
    }

    const handleSave = () => {
        // Logic to handle adding a new license plate   
        if (showModalDetail.record) {
            handleSaveEdit();
            return; // Prevent adding empty license plate
        } else {
            handleAddNew();
            return;
        }
    }

    const handleAcceptDelete = async (record) => {
        // Logic to handle accepting delete action
        try {
            await licensePlateWatchlistAPI.deleteLicensePlate(record?.CODE);
            setRefresh(pre => !pre);
            setShowAlertDelete({
                show: false,
                record: null,
            });
            Toast.open("Xoá biển số xe thành công", "success");
        } catch (error) {
            Toast.open("Xoá biển số xe thất bại", "danger");
        }
    }

    const handleChangeSearchText = (value) => {
        // Logic to handle search text change
        setSearchText(value);
        setPages(pre => ({
            ...pre,
            current: 1, // Reset to first page on search
        }));
    }

    const handleChosePage = (page) => {
        // Logic to handle page change
        setPages(pre => ({
            ...pre,
            current: page,
        }));
    }

    const handleNextPage = () => {
        // Logic to handle next page            
        setPages(pre => ({
            ...pre,
            current: pre.current + 1,
        }));
    }
    const handlePrePage = () => {
        // Logic to handle previous page
        setPages(pre => ({
            ...pre,
            current: pre.current - 1,
        }));
    }

    useEffect(() => {
        // Fetch initial data for the watchlist
        const getWatchlistData = async () => {
            setLoading(true);
            try {
                // Simulate fetching data from an API
                const params = {
                    licensePlate: searchText ? searchText.trim() : undefined,
                    page: pages?.current,
                    size: pages?.pageSize,
                }
                const res = await licensePlateWatchlistAPI.getWatchlist(params);
                const formattedData = res?.data?.map((item, index) => ({
                    stt: index + 1,
                    licensePlate: item.LICENCE_PLATE,
                    timeAdded: item?.EDIT_TIME,
                    objectType: item.OBJECT_TYPE,
                    ...item
                }));
                setDataSource(formattedData);
                setPages(pre => ({
                    ...pre,
                    current: formattedData?.length > 0 ? pre?.current : 1,
                    totalPage: Math.ceil(res.count / pre?.pageSize),
                }));
                setLoading(false);
            } catch (error) {
                setLoading(false);
            }
        }
        getWatchlistData();
    }, [searchText, refresh, pages?.current]);

    const columns = [
        {
            title: "STT",
            dataIndex: "stt",
            key: "stt",
            width: 50,
        },
        {
            title: "Biển số xe",
            dataIndex: "licensePlate",
            key: "licensePlate",
        },
        {
            title: "Loại xe",
            dataIndex: "objectType",
            key: "objectType",
            render: (_, record) => {
                const type = objectType.find(item => item.value === record?.objectType);
                return type ? type?.label : "Không xác định";
            }
        },
        {
            title: "Thời gian thêm",
            dataIndex: "timeAdded",
            key: "timeAdded",
            render: (_, record) => formatDateToTime(record?.timeAdded),
        },
        {
            title: "Hành động",
            dataIndex: "action",
            key: "action",
            align: 'center',
            width: 180,
            render: (_, record) => (
                <Space size="small">
                    <Button className={cx('act-btn')} onClick={() => handleEdit(record)}><EditIcon /></Button>
                    <Button className={cx('act-btn')} onClick={() => handleDelete(record)}><DeleteIcon /></Button>
                </Space>
            ),
        },
    ];

    const formInput = [
        {
            label: 'Loại xe',
            type: "radio",
            name: "objectType",
            span: 24,
            options: objectType,
            rules: [{ required: true, message: 'Vui lòng chọn loại xe' }],
            defaultValue: 'car', // Default value for the radio button
        },
        {
            label: 'Biển số xe',
            type: "input",
            name: "licensePlate",
            span: 24,
            placeholder: "Vd: 29-F1/123.45",
            rules: [{ required: true, message: 'Vui lòng nhập biển số xe' }],
        },
    ]
    return (
        <Space size={"small"} direction="vertical" className={cx('wrapper-watchlist')} >
            <Space size={"large"} justify="space-between" className={cx('filter-watchlist')}>
                <Input
                    placeholder="Nhập biển số xe"
                    style={{ width: "100%" }}
                    className={cx('input-watchlist')}
                    value={searchText}
                    onChange={(e) => handleChangeSearchText(e.target.value)}
                />
                <AntdButtonCustom title={'Thêm mới'} onClick={() => handleEdit(null)} />
            </Space>
            <AntdTableCustom
                columns={columns}
                dataSource={dataSource}
                loading={loading}
            />
            <Space className={cx('footer-table')}>
                <Pagination
                    currentPage={pages.current}
                    pages={pages.totalPage}
                    onClick={handleChosePage}
                    onNext={handleNextPage}
                    onPrev={handlePrePage}
                />
            </Space>
            <Modal
                title={showModalDetail.record ? "Chỉnh biển số xe theo dõi" : "Thêm mới biển số xe theo dõi"}
                open={showModalDetail.show}
                onCancel={() => handleCancelModal()}
                footer={[
                    <Button className={cx('btn-cancle', 'btn-modal')} key="back" onClick={() => handleCancelModal()}>
                        Đóng
                    </Button>,
                    <Button className={cx('btn-save', 'btn-modal')} key="submit" type="primary" onClick={() => handleSave()}>
                        Lưu
                    </Button>,
                ]}
                centered
                destroyOnClose
            >
                <Space direction="vertical" size={"middle"} className={cx('space-modal')} >
                    <FormInfo form={form} listInfo={formInput} />
                </Space>
            </Modal>
            {showAlertDelete?.show && (
                <Alert
                    title="Xoá biển số xe theo dõi"
                    content={`Bạn có chắc chắn muốn xoá biển số xe ${showAlertDelete?.record?.licensePlate} khỏi danh sách theo dõi?`}
                    onClose={() => setShowAlertDelete({ show: false, record: null })}
                    onOk={() => handleAcceptDelete(showAlertDelete.record)}
                />
            )}
        </Space>
    );
}